import React from "react";
import service from "../../../assets/img/home/project-banner-new.jpeg"
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

function Project_banner () {
    return(
      <>
            <Helmet> <title>Projects | GreenDart Builders</title> </Helmet>
        <div class="page-title" style={{ backgroundImage: `url(${service})`}}>
      {/* <div class="container position-relative">
        <h1 className="sub-banner-header">Project</h1>
        <nav class="breadcrumbs">
          <ol>
            <li><Link className="text-white" to="/">Home</Link></li>
            <li className="current">Project</li>
          </ol>
        </nav>
      </div> */}
    </div>
      </>

    )
}
export default Project_banner;